'use client'

import { NextIntlClientProvider as IntlProvider } from 'next-intl'

export default function Intl({
  children,
  locale,
  messages,
}: {
  children: React.ReactNode
  locale: string
  messages: any
}) {
  const cm = getCachedMessages(locale) || messages

  // Cache messages for subsequent navigation
  if (!getCachedMessages(locale)) {
    cacheMessages(locale, messages)
  }

  return (
    <IntlProvider
      locale={locale}
      messages={cm}
      timeZone='UTC'
      onError={(error) => {
        console.error('Translation error:', error)
      }}
      getMessageFallback={({ namespace, key, error }) => {
        // Return a sensible fallback instead of error
        return `${namespace ? `${namespace}.` : ''}${key}`
      }}
    >
      {children}
    </IntlProvider>
  )
}

let cachedMessages: Record<string, any> = {}

export function cacheMessages(locale: string, messages: any) {
  cachedMessages[locale] = messages
}

export function getCachedMessages(locale: string) {
  return cachedMessages[locale]
}
